import api from './api';
import logger from '../utils/logger';

/**
 * Analytics Service - Handles visitor tracking and analytics
 */
class AnalyticsService {
  /**
   * Log visitor IP and related information
   * @param {Object} data - Additional data to log with the IP
   * @returns {Promise} - API response
   */
  logVisitorIp(data = {}) {
    logger.debug('Logging visitor IP with data:', data);
    return api.post('/analytics/visitor-log', data);
  }

  /**
   * Log ad interaction
   * @param {String} adId - ID of the ad that was interacted with
   * @param {String} interactionType - Type of interaction (view, click, etc.)
   * @param {Object} additionalData - Any additional data to log
   * @returns {Promise} - API response
   */
  logAdInteraction(adId, interactionType, additionalData = {}) {
    logger.debug(`Logging ad interaction: ${interactionType} for ad ${adId}`);
    return api.post('/analytics/ad-interaction', {
      adId,
      interactionType,
      ...additionalData
    });
  }

  /**
   * Track page visits
   * @param {String} pageType - Type of page (category, product, product-detail, cart)
   * @param {Object} pageData - Data related to the page (e.g., product ID, category ID)
   * @param {Object} additionalData - Any additional tracking data
   * @returns {Promise} - API response
   */
  trackPageVisit(pageType, pageData = {}, additionalData = {}) {
    logger.debug(`Tracking page visit: ${pageType}`, pageData);
    return api.post('/analytics/page-visit', {
      pageType: pageType,
      pageData: pageData,
      timestamp: new Date().toISOString(),
      url: window.location.href,
      ...additionalData
    });
  }

  /**
   * Get analytics dashboard data
   * @param {Object} params - Query parameters like startDate and endDate
   * @returns {Promise} - API response with analytics data
   */
  getDashboardData(params = {}) {
    return api.get('/admin/analytics/dashboard', { params });
  }
}

export default new AnalyticsService();
